import React,{useState} from 'react'
import styled from 'styled-components'
import SocialSection from './SocialSection'

export default function Contact() {
    const [feedback, setFeedback] = useState({name:"",email:"",message:""});
    const [loading,setLoading]=useState(false);
    const handleSubmit=async (event)=>{
        setLoading(true);
        event.preventDefault();
        const {name,email,message}=feedback;
        if(name==="" || email==="" || message===""){
            setLoading(false);
            return;
        }
        const response=await fetch(`${process.env.REACT_APP_URI}/feedback`,{
            method:"POST",
            headers:{
                'Content-Type':'application/json'
            },
            body: JSON.stringify(feedback)
        });
        const result=await response.json()
        if(result){
            setLoading(false);
            console.log("Feedback sent")
        }
        else{
            setLoading(false);
            console.log("Something went wrong!")
        }
    }
    const handleChange=(event)=>{
        setFeedback({...feedback,[event.target.name]:event.target.value});
    }
    return (
        <Wrapper id="contact">
            <h3 className="section-heading">
                <span><i className="fa-solid fa-id-card  color-white"></i></span>
                <span className="color-white">Contact</span>
            </h3>
            <div className="contact-display">
                <div className="contact-input-field">
                    <form onSubmit={handleSubmit}>
                        <input value={feedback.name} id="name" name='name' type="text" placeholder="Your Name" onChange={handleChange} />
                        <input value={feedback.email} id="email" name="email" type="email" placeholder="Your Email" onChange={handleChange} />
                        <textarea value={feedback.message} name="message" id="message" placeholder="Message" cols="30" rows="10" onChange={handleChange}></textarea>
                        {
                            loading?<img className='loading-img' src="https://cdn.dribbble.com/users/47268/screenshots/4623785/loading_dots.gif" ></img>:<input type="submit" value="SEND MESSAGE" />
                        }
                    </form>
                </div>
                <div className="contact-input-details">
                    <h3>Get In touch</h3>
                    <p>I am exicted for you inquiry or for any feedback. You can contact me anytime by filling the form, I will get back to you ASAP. For more information email me.</p>
                    <h3>My Address</h3>
                    <p>Delhi, India</p>
                    <p>Bhushanverma.verma@gmail.com</p>
                </div>
                <div id="social-section-contact">
                    <SocialSection />
                </div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div`

width: 100%;
display: flex;
flex-direction: column;
align-items: center;
margin-top: 40px;
background-color:rgb(29, 28, 33);

#contact {
    color: white;
    background-image: var(--gradient-color);
}


.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    margin-right: .5rem;
}

.loading-img{
    width:12rem;
    height:4rem;
    border-radius: 4rem;
    cursor: not-allowed;
}

.contact-display {
    display: flex;
    justify-content: space-around;
    width: 80%;
    color: white;
    padding-bottom: 2rem;
}

.contact-input-field {
    margin: auto 2rem;
    width: 50%;
}

.contact-input-field>form {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
}

.contact-input-field>form>input {
    border: 0;
    height: 2rem;
    width: 100%;
    padding: 1rem;
    color:white;
    border-bottom: 4px solid white;
    background-color: transparent;
}

#message{
    resize: none;
}

.contact-input-field>form>textarea {
    border: 0;
    height: 2rem;
    padding: 1rem;
    color:white;
    width: 100%;
    border-bottom: 4px solid white;
    background-color: transparent;
}

.contact-input-field>form>input[type="submit"] {
    border: 4px solid white;
    padding-bottom: 2rem;
    background-color: transparent;
    cursor: pointer;
    border-radius: 1rem;
    transition: all .5s ease-in-out;
}

.contact-input-field>form>input[type="submit"]:hover{
    background-color: var(--section-color);
}

textarea:focus {
    outline: none;
}

input:focus{
    outline: none;
}

#social-section-contact {
    h1{
        display:none;
    }
    align-items: center;
    display: flex;
    padding-bottom: 4rem;
}

.contact-input-details {
    width: 50%;
}


    
.social-icons {
    display: flex;
    gap: 1rem;
    list-style: none;
    justify-content: center;
}

.social-icons svg {
    color: white;
    width: 20px;
    height: 20px;
    padding: 10px;
    border-radius: 50%;
}

.social-icons svg:hover {
    transition: border-radius .4s, box-shadow .5s;
    box-shadow: 0px 0px 15px 4px rgba(230, 196, 196, 0.3);
}

@media screen and (max-width:950px){
    .contact-display{
        flex-direction: column;
        align-items: center;
        width: 100%; 
        .social-section-contact{
        width: 80%;
        }
    }
    .contact-input-field {
        width: 80%;
    }
    .contact-input-details {
    width: 80%;
    }
    .social-icons{
        width: 100%;
        justify-content: space-around;
    }
}
`